<template>
    <div class="m-fristStep">
        <choose-park :is-choose="true" ref="choosePark" :choose-ids="chooseIds"  :init-choose-ids="initChooseIds" @changeProject="changeProject"  :is-register="isRegister"/>
    </div>
</template>

<script>
import choosePark from '@/components/choosePark';

export default {
    props: {
        chooseIds: { //默认选中的园区ID
            type: Array,
            default: ()=>{
                return []
            }
        },
        initChooseIds: { //默认选中的园区ID
            type: Array,
            default: ()=>{
                return []
            }
        },
        isRegister: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {

        }
    },
    components: {
        choosePark
    },
    methods: {
        getParkList(){//获取选中园区，避免没点击
            return this.$refs.choosePark.getParkList();
        },
        changeProject(list){
            this.$emit('changeProject', list)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../style/variable';
    .m-fristStep{
        margin-right: 20px;
    }
</style>